<ng-container *ngIf="isProcessAssociated">
    <div *ngIf="release.isProcessDeleted"
         translate
         class="alert alert-warning">
        processes_versions_process_deleted_warning
    </div>

    <div class="processes-global-actions">
        <button [disabled]="!isProcessAssociated || (loading$ | async) || isUpdatedToLatestVersion"
                [uiAuthorize]="'Processes.Edit'"
                (click)="onUpdateToLatestClick()"
                mat-button
                data-cy="versions-update-to-latest-button"
                type="button">
            {{'processes_versions_modal_latest' | translate}}
        </button>

        <button [disabled]="!isProcessAssociated || (loading$ | async) || isFirstVersion"
                [uiAuthorize]="'Processes.Edit'"
                (click)="onRollbackToPreviousClick()"
                mat-button
                data-cy="versions-rollback-button"
                type="button">
            {{'processes_versions_modal_rollback' | translate}}
        </button>
    </div>

    <ui-grid [data]="data$ | async"
             [loading]="loading$ | async"
             [selectable]="false">
        <ui-grid-column [title]="'processes_versions_modal_grid_version' | translate"
                        [resizeable]="false"
                        property="version"
                        sort="desc"
                        width="40%">
            <ng-template let-entry="data">
                {{entry.key.split(':')[1]}}
                <span *ngIf="processVersionIsCurrentVersion(entry)"
                      translate
                      class="tag tag-primary">
                    processes_versions_modal_current
                </span>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column [title]="'processes_versions_modal_grid_published' | translate"
                        [resizeable]="false"
                        property="published"
                        width="30%">
            <ng-template let-entry="data">
                <ui-dateformat #publishedFormat
                               [matTooltip]="publishedFormat?.dataset['title']"
                               [date]="entry.published"
                               contentType="relative"></ui-dateformat>
            </ng-template>
        </ui-grid-column>

        <ui-grid-column [sortable]="false"
                        [title]="'processes_versions_modal_grid_used' | translate"
                        [resizeable]="false"
                        width="30%">
            <ng-template let-entry="data">
                <ui-dateformat #usageDateFormat
                               [matTooltip]="usageDateFormat?.dataset['title']"
                               [date]="getProcessVersionUsageDate(entry)"
                               contentType="relative"></ui-dateformat>
            </ng-template>
        </ui-grid-column>

        <ui-grid-row-action>
            <ng-template let-index="index"
                         let-entry="data">
                <button [uiAuthorize]="'Processes.Edit'"
                        [disabled]="(loading$ | async) || processVersionIsCurrentVersion(entry)"
                        [matTooltip]="'processes_versions_modal_grid_use_tooltip' | translate"
                        [uiClickTrack]="'Action: Grid: Use'"
                        (click)="onUpdateClick(entry)"
                        mat-icon-button
                        data-cy="versions-use-button"
                        type="button">
                    <mat-icon>file_upload</mat-icon>
                </button>
            </ng-template>
        </ui-grid-row-action>

        <ui-grid-footer [length]="total$ | async"
                        [pageSize]="pageSize"
                        [pageSizes]="pageSizes">
        </ui-grid-footer>

    </ui-grid>
</ng-container>

<div *ngIf="!isProcessAssociated"
     translate
     style="text-align:center;"
     class="alert alert-warning">
    processes_versions_process_associated_warning
</div>
